// extracted by mini-css-extract-plugin
export default {"error":"Error-modules__error__CCQbK"};